function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.229166 13.22917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 7.3436925,8.564513e-5 c 0,0 -0.4463559,0.0041248049 -0.4479441,0.0037266049 C 6.7193891,0.00449429 6.55171,0.15155836 6.4575071,0.30065177 l -0.271479,0.4246709 H 9.6764736 C 9.9617503,0.72219523 10.114845,1.0594848 9.9246833,1.2721591 L 6.0774365,5.606129 h 3.5951588 c 0.307951,-0.00258 0.4495077,0.3821952 0.213305,0.5798018 l -7.989242,6.7249252 c 0.2504877,0.5778 1.1180151,0.207049 1.2042038,0.131865 L 11.495383,5.9260865 c 0.366722,-0.310657 0.147085,-0.9093021 -0.333531,-0.909455 H 8.4509394 L 11.856062,0.84360999 C 12.132917,0.50644023 11.892872,-6.2919487e-4 11.4566,8.564513e-5 Z M 5.1679814,1.3826898 1.2548042,7.2330644 h 3.7347767 c 0.2705148,2.96e-4 0.4244946,0.3093962 0.2617834,0.5255059 L 2.16232,11.828819 8.7747751,6.2615571 H 5.3483212 C 5.0660093,6.261489 4.9155606,5.9286064 5.1020508,5.7166597 L 8.9473584,1.3826898 Z",
    style: {
      strokeWidth: 0.999996
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.1644f44ea9a85fc980964ec85ded2564.svg";
export { ForwardRef as ReactComponent };